<div class="ofi-header" color="white">
  <div class="ofi-header-row forms-header__toolbar-row">
    <div class="forms-header__column forms-header__title">
      <img
        #logo
        class="forms-header__logo"
        src="https://cdn.orthofi.com/img/logos/logo-2019-blue.svg"
        alt="OrthoFi Logo"
      />
    </div>
  </div>
</div>
